'use strict';

var _classCallCheck = require("/Users/jatheepankanthavel/Documents/repo/slimola/webclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/jatheepankanthavel/Documents/repo/slimola/webclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var Ref = require('./ref');

module.exports =
/*#__PURE__*/
function () {
  function Set() {
    _classCallCheck(this, Set);

    this._set = [];
  }

  _createClass(Set, [{
    key: "add",
    value: function add(value, refs) {
      if (!Ref.isRef(value) && this.has(value, null, null, false)) {
        return;
      }

      if (refs !== undefined) {
        // If it's a merge, we don't have any refs
        Ref.push(refs, value);
      }

      this._set.push(value);

      return this;
    }
  }, {
    key: "merge",
    value: function merge(add, remove) {
      for (var i = 0; i < add._set.length; ++i) {
        this.add(add._set[i]);
      }

      for (var _i = 0; _i < remove._set.length; ++_i) {
        this.remove(remove._set[_i]);
      }

      return this;
    }
  }, {
    key: "remove",
    value: function remove(value) {
      this._set = this._set.filter(function (item) {
        return value !== item;
      });
      return this;
    }
  }, {
    key: "has",
    value: function has(value, state, options, insensitive) {
      for (var i = 0; i < this._set.length; ++i) {
        var items = this._set[i];

        if (state && Ref.isRef(items)) {
          // Only resolve references if there is a state, otherwise it's a merge
          items = items(state.reference || state.parent, options);
        }

        if (!Array.isArray(items)) {
          items = [items];
        }

        for (var j = 0; j < items.length; ++j) {
          var item = items[j];

          if (typeof value !== typeof item) {
            continue;
          }

          if (value === item || value instanceof Date && item instanceof Date && value.getTime() === item.getTime() || insensitive && typeof value === 'string' && value.toLowerCase() === item.toLowerCase() || Buffer.isBuffer(value) && Buffer.isBuffer(item) && value.length === item.length && value.toString('binary') === item.toString('binary')) {
            return true;
          }
        }
      }

      return false;
    }
  }, {
    key: "values",
    value: function values(options) {
      if (options && options.stripUndefined) {
        var values = [];

        for (var i = 0; i < this._set.length; ++i) {
          var item = this._set[i];

          if (item !== undefined) {
            values.push(item);
          }
        }

        return values;
      }

      return this._set.slice();
    }
  }, {
    key: "slice",
    value: function slice() {
      var newSet = new Set();
      newSet._set = this._set.slice();
      return newSet;
    }
  }, {
    key: "concat",
    value: function concat(source) {
      var newSet = new Set();
      newSet._set = this._set.concat(source._set);
      return newSet;
    }
  }]);

  return Set;
}();